<template>
  <media-table ref="table" :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import mediaTable from './table'

export default {
  components: {
    mediaTable
  },
  computed: {
    ...mapState('members', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/media/all.vue